import api from './utils/api';

class LanguagesService {
  async listLanguages() {
    const result = await api.get('/languages');
    return result.data;
  }

  async listLanguagesModel(id) {
    const result = await api.get(`/model-languages/${id}`);
    return result.data;
  }

  async upsertModelLanguages(data) {
    const result = await api.put('/model-languages', data);

    return result;
  }

  async deleteModelLanguages(id) {
    await api.delete(`/model-languages/${id}`);
  }
}

export default new LanguagesService();
